const PlayerSettings = {
	playSpeedStep: 0.25,
	defaultPlaySpeed: 1,
	maxPlaySpeed: 2,

	defaultVolume: 0.5,
};

export interface SpeedStep {
	name: string,
	value: number,
}

const speedSteps: SpeedStep[] = [
	{
		name: '2x',
		value: 2,
	},
	{
		name: '1.75x',
		value: 1.75,
	},
	{
		name: '1.5x',
		value: 1.5,
	},
	{
		name: '1.25x',
		value: 1.25,
	},
	{
		name: '1x',
		value: 1,
	},
	{
		name: '0.75x',
		value: 0.75,
	},
	{
		name: '0.5x',
		value: 0.5,
	},
	{
		name: '0.25x',
		value: 0.25,
	},
];

export {
	PlayerSettings,
	speedSteps
};
